import { render, staticRenderFns } from "./AddCourseCategory.vue?vue&type=template&id=3771d352&scoped=true"
import script from "./AddCourseCategory.vue?vue&type=script&lang=js"
export * from "./AddCourseCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3771d352",
  null
  
)

export default component.exports